var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReduce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9551 0.0820312L9.93945 1.20364C9.93945 1.20364 7.71289 3.67776 5.48633 6.87763C3.25977 10.0775 0.955078 13.9206 0.955078 17.137C0.955078 21.8131 5.41797 25.582 10.9551 25.582C16.4922 25.582 20.9551 21.8131 20.9551 17.137C20.9551 13.9206 18.6504 10.0775 16.4238 6.87763C14.1973 3.67776 11.9707 1.20364 11.9707 1.20364L10.9551 0.0820312ZM10.9551 3.74374C11.6338 4.53546 12.5908 5.60758 14.2363 7.96625C16.3848 11.0507 18.4551 14.8649 18.4551 17.137C18.4551 20.6956 15.1689 23.4708 10.9551 23.4708C6.74121 23.4708 3.45508 20.6956 3.45508 17.137C3.45508 14.8649 5.52539 11.0507 7.67383 7.96625C9.31934 5.60758 10.2764 4.53546 10.9551 3.74374Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9551 4.58203L19.9395 5.70364C19.9395 5.70364 17.7129 8.17776 15.4863 11.3776C13.2598 14.5775 10.9551 18.4206 10.9551 21.637C10.9551 26.3131 15.418 30.082 20.9551 30.082C26.4922 30.082 30.9551 26.3131 30.9551 21.637C30.9551 18.4206 28.6504 14.5775 26.4238 11.3776C24.1973 8.17776 21.9707 5.70364 21.9707 5.70364L20.9551 4.58203ZM20.9551 8.24374C21.6338 9.03546 22.5908 10.1076 24.2363 12.4662C26.3848 15.5507 28.4551 19.3649 28.4551 21.637C28.4551 25.1956 25.1689 27.9708 20.9551 27.9708C16.7412 27.9708 13.4551 25.1956 13.4551 21.637C13.4551 19.3649 15.5254 15.5507 17.6738 12.4662C19.3193 10.1076 20.2764 9.03546 20.9551 8.24374Z",
    fill: "#04F4AE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduce);
export default __webpack_public_path__ + "static/media/reduce.7fcb1553471aa0bed7716a9f63838d78.svg";
export { ForwardRef as ReactComponent };